import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { useToast } from "../../../../../../shared/hooks";
import { ToastContent } from "../../../../../../shared/components";
import { ICancelProposal, ProposalService } from "../../../../../../shared/services/api/proposal/ProposalService";
import { ProposalDocumentsService } from "../../../../../../shared/services/api/proposal/ProposalDocumentsService";

export function useCancelProposal({ proposalId, createdAt }: { proposalId: string; createdAt: string }) {
	const toast = useToast();
	const navigate = useNavigate();
	const [isSubmitting, setIsSubmitting] = useState(false);

	const submit = async (data: ICancelProposal, file?: File) => {
		const now = new Date();
		const selected = new Date(data.canceledAt);
		const created = new Date(createdAt);

		if (selected > now) {
			toast.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content="A data de cancelamento não pode ser maior que a data atual." />,
			});
			throw new Error("invalid-date");
		}

		if (selected < created) {
			toast.present({
				type: "error",
				position: "top-right",
				messageOrContent: (
					<ToastContent title="Erro" content={`A data de cancelamento não pode ser anterior à data de criação (${format(created, "dd/MM/yyyy")}).`} />
				),
			});
			throw new Error("invalid-date");
		}

		setIsSubmitting(true);
		try {
			if (file) {
				const uploadResult = await ProposalDocumentsService.uploadProposalDocument(proposalId, "cd8a1b83-35ec-4dfc-a837-513e494007e8", file);
				if (uploadResult.status === 400) throw new Error(uploadResult.data.message);
			}

			const result = await ProposalService.updateCanceledId(proposalId, data);
			if (result instanceof Error) throw result;

			toast.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title="Sucesso" content="Cancelamento iniciado com sucesso." />,
			});
			navigate("/garantias/");
		} catch (error: any) {
			toast.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content={error.message || "Erro ao cancelar garantia"} />,
			});
		} finally {
			setIsSubmitting(false);
		}
	};

	return { isSubmitting, submit };
}
